/**
 * Qui peut envoyer un email relation client depuis la fiche.
 * Aligné sur clients:email : GERANT, MANAGER, commerçant sans rôle interne,
 * Super Admin (la boutique effective est imposée par le token d'assistance).
 */
export function canSendClientRelationEmail(user) {
  if (!user) return false;
  if (user.role === 'SUPER_ADMIN') return true;
  if (user.role !== 'COMMERCANT') return false;
  if (!user.roleInterne) return true;
  return user.roleInterne === 'GERANT' || user.roleInterne === 'MANAGER';
}
